/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Review_TitleInputs */

const en_consumer_declaration_review_title = /** @type {(inputs: Consumer_Declaration_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review your declaration`)
};

const de_consumer_declaration_review_title = /** @type {(inputs: Consumer_Declaration_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklärung prüfen`)
};

const fr_consumer_declaration_review_title = /** @type {(inputs: Consumer_Declaration_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez votre déclaration`)
};

const es_consumer_declaration_review_title = /** @type {(inputs: Consumer_Declaration_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu declaración`)
};

const it_consumer_declaration_review_title = /** @type {(inputs: Consumer_Declaration_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla la dichiarazione`)
};

const nl_consumer_declaration_review_title = /** @type {(inputs: Consumer_Declaration_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleer je verklaring`)
};

const pl_consumer_declaration_review_title = /** @type {(inputs: Consumer_Declaration_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź oświadczenie`)
};

const fi_consumer_declaration_review_title = /** @type {(inputs: Consumer_Declaration_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkista ilmoituksesi`)
};

const da_consumer_declaration_review_title = /** @type {(inputs: Consumer_Declaration_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollér din erklæring`)
};

const sv_consumer_declaration_review_title = /** @type {(inputs: Consumer_Declaration_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollera din förklaring`)
};

/**
* | output |
* | --- |
* | "Review your declaration" |
*
* @param {Consumer_Declaration_Review_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_review_title = /** @type {((inputs?: Consumer_Declaration_Review_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Review_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_review_title(inputs)
	if (locale === "fr") return fr_consumer_declaration_review_title(inputs)
	if (locale === "es") return es_consumer_declaration_review_title(inputs)
	if (locale === "it") return it_consumer_declaration_review_title(inputs)
	if (locale === "nl") return nl_consumer_declaration_review_title(inputs)
	if (locale === "pl") return pl_consumer_declaration_review_title(inputs)
	if (locale === "fi") return fi_consumer_declaration_review_title(inputs)
	if (locale === "da") return da_consumer_declaration_review_title(inputs)
	if (locale === "sv") return sv_consumer_declaration_review_title(inputs)
	return en_consumer_declaration_review_title(inputs)
});